import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  InputNumber,
  Row,
  Col,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";

const ShopPopup = ({ show, close, details }) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [categoryList, setCategoryList] = useState([]);
  const [fileList, setFileList] = useState();

  useEffect(() => {
    try {
      (async () => {
        form.setFieldsValue({
          name: details.name,
          parentId: details.parentId,
          discount: details.discount,
          lowDiscount: details.lowDiscount,
        });

        if (details && details.variants) {
          form.setFieldsValue({
            variants: details && details.variants,
          });
        }

        let data = await axios.get("/category-golbal").catch((error) => {
          Helper.ErrorHanlder(error);
        });

        if (data && data.data) setCategoryList(data.data.data);
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
    // eslint-disable-next-line
  }, []);

  const handleOk = async () => {
    try {
      let obj = { ...{ id: details.id }, ...form.getFieldsValue() };
      if (obj.name) {
        obj.image = fileList;
        const data = await axios
          .post("/category-create", obj)
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) close(data);
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleCancel = () => {
    close();
  };

  const imageUpload = async ({ file, onSuccess }) => {
    var formData = new FormData();
    formData.append("image", file);
    let data = await axios
      .post("web-image-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      setFileList(data.data?.files[0]);
      onSuccess("ok");
    }
  };

  return (
    <>
      <Modal
        title={details ? "Update Category" : "Create Category"}
        open={show}
        onCancel={handleCancel}
        footer={false}
        width={500}
      >
        <Form
          layout={"vertical"}
          form={form}
          size={"default"}
          style={{
            marginTop: 30,
          }}
        >
          <Row>
            <Col md={24}>
              <Form.Item
                label="Category Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Category Name is required",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item label="Hight Price (%)" name="discount">
                <InputNumber />
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item label="Low Price (%)" name="lowDiscount">
                <InputNumber />
              </Form.Item>
            </Col>
            <Col md={8}>
              {details.id && (
                <Form.Item label="Change Price (%)" name="changePrice">
                  <InputNumber />
                </Form.Item>
              )}
            </Col>
            <Col md={24}>
              <Form.Item>
                <Upload
                  customRequest={imageUpload}
                  className="custom-upload"
                  listType="picture"
                  defaultFileList={
                    details.image || fileList
                      ? [
                          {
                            uid: Date.now(),
                            name: details.image,
                            status: "done",
                            url: `https://thecharmingtreasure.in/uploads/${
                              fileList ? fileList : details.image
                            }`,
                          },
                        ]
                      : []
                  }
                  name="image"
                  maxCount={1}
                  onRemove={async (file) => {
                    try {
                      await axios.post("/delete-image", {
                        filename: fileList ? fileList : details.image,
                      });

                      setFileList("");

                      return true;
                    } catch (error) {
                      alert("Failed to delete image");
                      return false; // prevents removal in UI
                    }
                  }}
                >
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col md={24}>
              <Form.Item className="popup-submit">
                <Button className="popup-cancel-btn" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="popup-submit-btn"
                  onClick={handleOk}
                >
                  {details.id ? "Update" : "Create"}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default ShopPopup;
